export default __webpack_public_path__ + "static/media/pxiEyp8kv8JHgFVrJJnecmNE.2d053191.woff2";